<template>
    <div class="flex contact-info-container">
        <div class="code-view flex item-center mr-10">
            <img @click="visible =true" :src="$i18n.locale === 'en'?qrCodeEn:qrCodeCn" class="qr-code mr-5">
            <div>
                <div class="font-bold">
                    {{ $t('newsMgt.overview') }}
                </div>
                <p class="scan-tips" v-if="$i18n.locale === 'en'">{{ $t('newsMgt.scanTips') }}</p> 
            </div>
        </div>
        <div class="pointer mr-10 flex introduction-video item-center">
            <img class="mr-10 icon-pic" src="@/assets/img/icon-introduction.png">
            <div>
                <div class="font-bold">
                    {{ $t('newsMgt.videoIntroduction') }}
                </div>
                <a class="onboard-link mr-5" @click="renderVideo('en')">{{ $t('newsMgt.videoList.en') }}</a>>
                <a class="onboard-link mr-5" @click="renderVideo('cn')">{{ $t('newsMgt.videoList.cn') }}</a>>
                <a class="onboard-link" @click="renderVideo('yueyu')">{{ $t('newsMgt.videoList.yueyu') }}</a>
            </div>
        </div>
        
        <div class="pointer flex contact-us item-center">
            <img class="icon-pic mr-5" src="@/assets/img/icon-contact.png">
            <a target="_top" href="mailto:cnfmkpmgclicbt@kpmg.com">{{ $t('newsMgt.contactTeam') }}</a>
        </div>

        <el-dialog
            :visible.sync="visible"
            custom-class='qrCode-dialog'
            center>
             <img  :src="$i18n.locale === 'en'?qrCodeEn4Dialog:qrCodeCn4Dialog" style="width:340px;height:420px">
        </el-dialog>
    </div>
</template>
<script>
import SvgIcon from "@/components/svgIcon/index";

export default{
    name:'ClientTopRight',
    components:{ SvgIcon },
    data(){
        return{
            visible:false,
            serviceDeskUrl:'https://oak-cn.cn.kworld.kpmg.com/#/user/createticketfromprofiles',
            video_En:'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_w9rnj0g7',
            video_cn:'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_ijojn7oa',
            video_yueyu:'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_flmep6c5',
            qrCodeCn:require(`@/assets/img/qrCodeCn-client.png`),
            qrCodeEn:require(`@/assets/img/qrCodeEn-client.png`),
            qrCodeCn4Dialog:require(`@/assets/img/qrCodeCn-clientBig.png`),
            qrCodeEn4Dialog:require(`@/assets/img/qrCodeEn-clientBig.png`)
        }
    },
    mounted(){
    },
    methods:{
        toOuterLink(url){
            if(!url) return
            window.open(url)
        },
        renderVideo(lang) {
            this.$showVideoDialog()
            localStorage.setItem('homepage_video_close_all', 1)
            this.$nextTick(() => {
                this.$chooseVideo(1, false,lang)
            })
        },
    }
}
</script>
<style scoped>

 ::v-deep .el-dialog__close.el-icon-close:before {
    content: "\E6DB";
    font-size: 28px;
    position: relative;
    top: 20px;
    color: #000000;
}
 ::v-deep .el-dialog__body{
    text-align: center !important;
}
.font-bold{
    font-weight: bold;
}

.contact-info-container{
    color: white;
    font-size: 12px;
    position: absolute;
    right: 0;
    top:-5px;
}


.icon-pic{
    width: 20px;
    height: 20px;
}
.introduction-video{
    padding: 5px;
    background: url('~@/assets/img/bg-Introduction.png') no-repeat;
    background-size: cover;
    cursor: pointer;
    border-radius: 4px;
}

.contact-us{
    padding: 5px;
    background: url('~@/assets/img/bg-contact.png') no-repeat;
    background-size: cover;
    border-radius: 4px;
}

.contact-us a {
    color: white;
    font-weight: bold;
}
.code-view{
    width: 200px;
    color: white;
    background:url('~@/assets/img/bg-Overview.png') no-repeat;
    background-size: cover;
    border-radius: 4px;
    padding: 5px;
}

.qr-code{
    width: 44PX;
    height: 44PX;
    cursor: pointer;
}

.scan-tips{
    font-size: 12px;
}
.onboard-link{
    text-decoration: underline;
}
</style>

<style>
    .qrCode-dialog{
        width: 440px !important;
        background: transparent !important;
        box-shadow: none !important;
    }
   .qrCode-dialog .el-dialog__header {
     background: transparent;
    }
   .qrCode-dialog .el-dialog__body {
     background: transparent;
    }
</style>